import { EMPTY_LIST } from '../../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'
import {
  LISTING_FORM_FIELD_NAME_AVAILABLE_FROM,
  LISTING_FORM_FIELD_NAME_BUILDING,
  LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT,
  LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT,
  LISTING_FORM_FIELD_NAME_DESCRIPTION,
  LISTING_FORM_FIELD_NAME_FLAT,
  LISTING_FORM_FIELD_NAME_PHOTOS,
  LISTING_FORM_FIELD_NAME_PORTALS,
  LISTING_FORM_FIELD_NAME_RENT_PRICE,
  LISTING_FORM_FIELD_NAME_SCHEDULED_DEACTIVATE,
  LISTING_FORM_FIELD_NAME_SCHEDULED_GO_LIVE,
  LISTING_FORM_FIELD_NAME_SERVICE_CHARGE,
} from '../../../RentalPortalListing'

export const QA_NAME_LISTING_FORM_SAVE_DRAFT = 'listingFormSaveDraft'

export const LISTING_FORM_FIELD_NAME_TIMING = 'timing'

export const LISTING_FORM_TIMING = {
  draft: 'draft',
  scheduled: 'scheduled',
}

export const LISTING_FORM_INITIAL_VALUES = {
  [LISTING_FORM_FIELD_NAME_AVAILABLE_FROM]: null,
  [LISTING_FORM_FIELD_NAME_BUILDING]: null,
  [LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT]: FORMIK_EMPTY_VALUE,
  [LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT]: FORMIK_EMPTY_VALUE,
  [LISTING_FORM_FIELD_NAME_DESCRIPTION]: FORMIK_EMPTY_VALUE,
  [LISTING_FORM_FIELD_NAME_FLAT]: null,
  [LISTING_FORM_FIELD_NAME_PHOTOS]: EMPTY_LIST,
  [LISTING_FORM_FIELD_NAME_PORTALS]: EMPTY_LIST,
  [LISTING_FORM_FIELD_NAME_RENT_PRICE]: FORMIK_EMPTY_VALUE,
  [LISTING_FORM_FIELD_NAME_SCHEDULED_DEACTIVATE]: null,
  [LISTING_FORM_FIELD_NAME_SCHEDULED_GO_LIVE]: null,
  [LISTING_FORM_FIELD_NAME_SERVICE_CHARGE]: FORMIK_EMPTY_VALUE,
  [LISTING_FORM_FIELD_NAME_TIMING]: LISTING_FORM_TIMING.scheduled,
}

export const LISTING_FORM_AD_MATERIAL_FIELD_NAMES = [
  LISTING_FORM_FIELD_NAME_AVAILABLE_FROM,
  LISTING_FORM_FIELD_NAME_BUILDING,
  LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT,
  LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT,
  LISTING_FORM_FIELD_NAME_DESCRIPTION,
  LISTING_FORM_FIELD_NAME_RENT_PRICE,
  LISTING_FORM_FIELD_NAME_SERVICE_CHARGE,
]
